import router from '../router'
export default {
  getUser (state, data) {
    state.btnLoading = true
  },
  clearUser (state) {
    state.user = {}
    router.push('/login')
  },
  setOrder (state, data) {
    state.order = data
  }
}



// WEBPACK FOOTER //
// ./src/vuex/mutations.js